var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 119,
    viewBox: "0 0 121 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64062,
    y: 1,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.64062,
    y: 3,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1806 93H51.9416V62.3703H40.6641V50.2666H51.4699V36.4338C51.4699 36.4338 51.9416 29.9874 57.5804 25.5408C63.2192 21.0943 77.684 23.8361 77.684 23.8361V33.6915C77.684 33.6915 68.6129 31.7161 66.1612 35.6684C63.7096 39.6207 65.1806 50.2666 65.1806 50.2666H77.684L74.4968 62.3703H65.1806V93Z",
    stroke: "#11141D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1806 95H54.9416V64.3703H43.6641V52.2666H54.4699V38.4338C54.4699 38.4338 54.9416 31.9874 60.5804 27.5408C66.2192 23.0943 80.684 25.8361 80.684 25.8361V35.6915C80.684 35.6915 71.6129 33.7161 69.1612 37.6684C66.7096 41.6207 68.1806 52.2666 68.1806 52.2666H80.684L77.4968 64.3703H68.1806V95Z",
    stroke: "#11141D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.facbecf5b25154d7bb00a6f5d06d9104.svg";
export { ForwardRef as ReactComponent };